const fromdata = [{
		inputdata: "",
		title: "产品线",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "select",
		width: "210px",
		lablewith: "110px",
		btx: false,
		event: 'invClass',
	}, {
		inputdata: "",
		title: "类型",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "select",
		width: "210px",
		lablewith: "88px",
		btx: false,
	},
	{
		inputdata: "",
		title: "政策名称",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "input",
		width: "200px",
		lablewith: "110px",
		btx: false,
	}, {
		inputdata: "",
		title: "执行日期",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "dates",
		widths: "210px",
		disabled: false,
		lablewith: "110px",
	},
	{
		inputdata: "",
		title: "省市",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "cascaderNodeParent",
		width: "210px",
		lablewith: "80px",
		multiple: true,
		height: '30px',
		btx: false,
	},
	{
		inputdata: "",
		title: "LEVEL3",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "selectMultiple",
		width: "210px",
		lablewith: "110px",
		btx: false,
	},
	{
		inputdata: "",
		title: "产品名称",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "selectMultiple",
		width: "210px",
		lablewith: "110px",
		btx: false,
	},
	{
		inputdata: "",
		title: "最低采购价",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "input",
		width: "200px",
		lablewith: "88px",
		btx: false,
	},
	{
		inputdata: "",
		title: "最高采购价",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "input",
		width: "200px",
		lablewith: "110px",
		btx: false,
	},
	{
		inputdata: "",
		title: "最高植入价",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "input",
		width: "200px",
		lablewith: "110px",
		btx: false,
	},
	{
		inputdata: "",
		title: "经销商",
		fontSize: "14px",
		color: "#333333",
		placeholder: "全部",
		types: "",
		inputtype: "selectautocompletemultiple",
		pt: true,
		width: "300px",
		btx: false,
		lablewith: "88px",
		options: [],
	},
	{
		inputdata: [],
		title: "医院",
		fontSize: "14px",
		color: "#333333",
		placeholder: "全部",
		types: "",
		inputtype: "selectautocompleteHP",
		pt: true,
		width: "300px",
		btx: false,
		lablewith: "110px",
		options: [],
		disabledHB: false,
		multiple: true,
	},
];
export default fromdata;